var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59362 16.2414C1.66004 16.2494 1.72719 16.2494 1.79362 16.2414L5.12695 15.408C5.27482 15.3729 5.41026 15.298 5.51862 15.1914L15.7603 4.91637C16.0707 4.6041 16.2449 4.18168 16.2449 3.74137C16.2449 3.30106 16.0707 2.87865 15.7603 2.56637L14.4436 1.24137C14.2888 1.08641 14.105 0.963482 13.9027 0.879608C13.7004 0.795735 13.4835 0.752563 13.2645 0.752563C13.0454 0.752563 12.8285 0.795735 12.6262 0.879608C12.4239 0.963482 12.2401 1.08641 12.0853 1.24137L1.84362 11.483C1.73594 11.5919 1.65841 11.7269 1.61862 11.8747L0.785285 15.208C0.755334 15.3159 0.747406 15.4286 0.761976 15.5396C0.776545 15.6505 0.813313 15.7574 0.870087 15.8538C0.92686 15.9503 1.00248 16.0343 1.09242 16.1009C1.18237 16.1675 1.2848 16.2152 1.39362 16.2414C1.46004 16.2494 1.52719 16.2494 1.59362 16.2414ZM13.2603 2.41637L14.5853 3.74137L13.2603 5.06637L11.9436 3.74137L13.2603 2.41637ZM3.18529 12.4997L10.7603 4.91637L12.0853 6.24137L4.50195 13.8247L2.74362 14.258L3.18529 12.4997Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.21cbadb4461df227a2d73215dc11754b.svg";
export { ForwardRef as ReactComponent };